import { useState } from 'react';
import classNames from 'classnames';

import {
  PerformanceIndicator,
  Table,
  useToggle } from
'~/components/OddscheckerPlus/components/cxy';
import { formatDate } from '~/configuration/betting-insights/utils/formatDate';

import { type ValueBetResult } from '../../types';

import styles from './styles/ResultCard.module.css';

export function ResultFooter({ data }: {data: ValueBetResult;}) {
  const [isOpen, setIsOpen] = useState(true);
  const { Indicator, headingProps, sectionProps, triggerClass } = useToggle({
    isOpen,
    onChange: setIsOpen
  });

  if (!data.sportsData?.history) {
    return null;
  }

  return (
    <Table.Footer className={styles.footer}>
			<Table.Row className={styles.footerRow}>
				<Table.Cell
          {...sectionProps}
          className={classNames(
            styles.footerCell,
            styles.footerSection,
            sectionProps.className
          )}
          role="cell">

					{data.betDescription}
				</Table.Cell>
				<Table.Cell
          {...headingProps}
          className={classNames(
            styles.indicatorCell,
            styles.footerCell,
            triggerClass
          )}
          role="cell">

					<PerformanceIndicator
            formatDate={formatDate}
            history={data.sportsData.history}
            hitRate={data.sportsData.hitRates.last10}
            showMatchInformation={isOpen} />

					<span className={styles.indicator}>
						<Indicator />
					</span>
				</Table.Cell>
			</Table.Row>
		</Table.Footer>);

}